import NotFound from '../../../base/pages/errorPages/NotFound';

const notFound: NotFound = {
  title: 'Stránka nenalezena',
  subtitle: 'Všichni děláme chyby, každý by měl dostat druhou šanci.',
  quip: 'Možná není jasné, co se stane, když to znovu zkusíte. Ale když nic nezkusíte, je to jasné – nestane se nic!'
};

export default notFound;
